import { ApolloLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';

import { markWrite } from './hasuraPrimaryReadWindow';

// An Apollo link that opens the "prefer (Hasura) primary" read window whenever
// a mutation completes. Shared by the Hasura and Main API Apollo clients
// so that a write through either one keeps subsequent reads on the Hasura primary
// service during the replication-lag window.

export function createTrackMutationsLink(): ApolloLink {
  return new ApolloLink((operation, forward) => {
    const definition = getMainDefinition(operation.query);
    const isMutation = definition.kind === 'OperationDefinition' && definition.operation === 'mutation';

    return forward(operation).map((result) => {
      if (isMutation) {
        markWrite();
      }

      return result;
    });
  });
}
